<template>
  <v-flex>
    <v-layout row justify-space-between>
      <h1>{{ name }}</h1>
    </v-layout>
    <v-card>
      <v-card-title>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          v-model="search"
          class="mr-3"
        ></v-text-field>
        <v-btn
          dark
          color="primary"
          style="margin-right: 0"
          v-if="distributor"
          @click.native="printAll()"
        >
          PRINT all
        </v-btn>
        <v-dialog v-model="dialog" persistent max-width="700" v-if="!distributor">
          <v-btn color="primary" dark slot="activator">Generate</v-btn>
          <codes-dialog
            :init="{}"
            :title="dialogTittle"
            :distributorInit="dId"
            @close="dialog = false"
            @save="addCodes"
            ref="dialog"
          ></codes-dialog>
        </v-dialog>
        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" v-if="distributor">
          <v-btn color="primary" dark slot="activator">Generate</v-btn>
          <distributor-dialog
            :title="dialogTittle"
            :distributor="distributorFull"
            @close="dialog = false"
            ref="dialog"
          ></distributor-dialog>
        </v-dialog>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="codesList"
        :search="searchTrimmed"
        :pagination.sync="pagination"
        :loading="loading"
        class="elevation-1"
      >
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <tr @click="props.expanded = !props.expanded">
            <td v-if="distributor">{{ props.item.order }}</td>
            <td><h3>{{ props.item.name }}</h3></td>
            <td>{{ props.item.blocksCount }}</td>
            <td>{{ props.item.sku.name }}</td>
            <td v-if="!distributor">{{ props.item.distributor.name }}</td>
            <td>{{ props.item.count }}
              <span v-if="props.item.activations">
                /
                <span class="red--text">{{props.item.activations.activated}}</span>
                <span class="green--text">{{props.item.activations.android}}</span>
                <span class="blue--text">{{props.item.activations.ios}}</span>
              </span>
            </td>
            <td>{{ props.item.createdAt | moment }}</td>
            <td class="red--text" v-bind:class="{ 'green--text': props.item.status === 'enabled' }">{{ props.item.status }}</td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <v-card flat>
            <v-card-text>
              <v-layout row justify-start>
                <div class="mr-5">
                  <span class="text-xs-center">Last update:</span>
                  <br>
                  <span class="text-xs-center">{{ props.item.updatedAt | moment }}</span>
                </div>
                <!--<div v-if="activationsInfo = props.item.activationsInfo"></div>-->
                <!--<div v-if="activationsInfo" class="ml-5">-->
                  <!--<span class="text-xs-center">Activated: {{activationsInfo.activated}}</span>-->
                  <!--<br>-->
                  <!--<span class="text-xs-center">iOS: {{activationsInfo.ios}}</span>-->
                  <!--<br>-->
                  <!--<span class="text-xs-center">Android: {{activationsInfo.android}}</span>-->
                <!--</div>-->
                <v-spacer></v-spacer>
                <!--<v-btn color="success"-->
                       <!--@click.native="props.item = getAllActivationsInfo(props.item)">-->
                  <!--activations info-->
                <!--</v-btn>-->
                <v-btn color="primary"
                       dark
                       @click.native="print(props.item)">
                  Print
                </v-btn>
                <v-btn color="primary"
                       dark
                       @click.native="$router.push(`/codes/${props.item.id}/list?p=${pagination.page}`)">
                  List
                </v-btn>
                <v-dialog v-if="props.item.status === 'disabled'" v-model="dialogEnable" max-width="400px">
                  <v-btn  class="green" slot="activator" dark>Enable</v-btn>
                  <v-card>
                    <v-card-title class="headline">Enable Codes?</v-card-title>
                    <v-card-text>
                      Are you sure you want to enable {{ props.item.name }}?<br/>
                      After that, users could activate this codes!
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="green darken-1" flat="flat" @click.native="dialogEnable = false">Cancel</v-btn>
                      <v-btn color="green darken-1" flat="flat" @click.native="enableCodes(props.item.id)">Enable</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-layout>
            </v-card-text>
          </v-card>
        </template>
      </v-data-table>
    </v-card>
    <!--<div class="text-xs-center pt-2">-->
      <!--<v-pagination v-model="pagination.page" :length="pages"></v-pagination>-->
    <!--</div>-->
    <v-snackbar
      :timeout="3000"
      :bottom="true"
      :right="true"
      :multi-line="false"
      v-model="snackBar"
    >
      {{ snackBarText }}
      <v-btn flat color="pink" @click.native="snackBar = false">Close</v-btn>
    </v-snackbar>
  </v-flex>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { CODES_LIST, CODES_ADD, CODES_ENABLE } from '../../store/actions/codes'
import CodesDialog from '@/components/Codes/Dialog'
import DistributorDialog from '@/components/Codes/DistributorDialog'
import api from '../../api/codes'

// {"auth":{"requestTime":"2018-08-16T14:18:34.634+03:00","token":"6d09e79b9bb3acfast9net1forrtnang"},"code":"123456","figure":{"id":"12"}}
export default {
  props: ['distributor'],
  data: () => ({
    name: 'Codes',
    dialog: false,
    dialogTittle: 'Generate Codes',
    dialogEnable: false,
    dId: null,
    search: '',
    totalItems: 0,
    items: [],
    loading: true,
    pagination: {
      page: 1,
      rowsPerPage: 25
    },
    headers: null,
    snackBarText: 'Codes with same name exist',
    snackBar: false,
    activationsInfo: null
  }),
  computed: {
    ...mapGetters([
      'codes',
      'codesTotalPages',
      'codesTotal'
    ]),
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 0
      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    },
    searchTrimmed () {
      return this.search.trim()
    },
    codesList () {
      if (this.dId) {
        return this.codes.filter(item => item.distributor.id === this.dId)
      }
      return this.codes
    },
    distributorFull () {
      if (this.dId) {
        return (this.$store.getters.distributorsById(this.dId))[0]
      }
      return null
    }
  },
  methods: {
    addCodes: async function (codes) {
      const newItem = await this.$store.dispatch(CODES_ADD, codes)
      if (!newItem) {
        this.snackBar = true
        this.$refs.dialog.stopLoading()
      } else {
        this.$refs.dialog.clear()
        this.dialog = false
        this.pagination.page = 1
      }
    },
    getActivationsInfo: async function (item) {
      const res = await api.getActivations(item.id)
      item.activationsInfo = res[0]
      this.activationsInfo = res[0]
      return item
    },
    getAllActivationsInfo: async function () {
      for (let i = 0; i < this.codes.length; i++) {
        if (this.codes[i].distributor.id === this.dId) {
          const activations = await api.getActivations(this.codes[i].id)
          this.codes[i].activations = activations[0]
          this.pagination = Object.assign({}, this.pagination)
        }
      }
    },
    enableCodes: async function (id) {
      await this.$store.dispatch(CODES_ENABLE, id)
      this.pagination = {...this.pagination}
      this.dialogEnable = false
    },
    download: function (filename, text) {
      const element = document.createElement('a')
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
      element.setAttribute('download', filename)
      element.style.display = 'none'
      document.body.appendChild(element)
      element.click()
      document.body.removeChild(element)
    },
    print: async function (code) {
      const text = await api.getCodesPrint(code.id)
      this.download(`${code.name}.txt`, text)
    },
    printAll: async function () {
      for (let i = 0; i < this.codesList.length; i++) {
        await this.print(this.codesList[i])
      }
    },
    init: async function () {
      if (!this.distributor) {
        this.headers = [
          {text: 'Codes Common Name  ', value: 'name'},
          {text: 'App Blocks', value: 'blocksCount'},
          {text: 'SKU     ', value: 'sku.name'},
          {text: 'Distributor', value: 'distributor.name'},
          {text: 'Codes count', value: 'count'},
          {text: 'Created At', value: 'createdAt'},
          {text: 'Status', value: 'status'}
        ]
      } else {
        this.headers = [
          {text: '#', value: 'order'},
          {text: 'Codes Common Name  ', value: 'name'},
          {text: 'App Blocks', value: 'blocksCount'},
          {text: 'SKU     ', value: 'sku.name'},
          {text: 'Codes count', value: 'count'},
          {text: 'Created At', value: 'createdAt'},
          {text: 'Status', value: 'status'}
        ]
      }
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('MMMM DD YYYY, hh:mm:ss')
    }
  },
  components: {
    CodesDialog,
    DistributorDialog
  },
  mounted: async function () {
    this.init()
    await this.$store.dispatch(CODES_LIST)
    this.dId = this.distributor
    this.loading = false
  },
  watch: {
    '$route': function (to) {
      if (to.query.p) {
        this.pagination.page = parseInt(to.query.p)
      }
    },
    distributor: function () {
      this.dId = this.distributor
      this.init()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Codes/Index.vue